<template>
  <div class="search">
    <img
      class="search-icon"
      src="https://s3.amazonaws.com/images.growmindgrow/school-site/search.svg"
      alt="search"
    >
    <input
      v-model="value"
      @input="$emit('update:inputValue', value)"
      type="text"
    >
    <v-icon
      v-if="value"
      @click="clear"
      class="clear-text"
    >
      close
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'SchSearch',
  props: {
    inputValue: {
      type: String || Number,
      required: true,
    },
  },
  data() {
    return {
      value: this.inputValue,
    };
  },
  methods: {
    clear() {
      this.value = '';
      this.$emit('update:inputValue', '');
    },
  },
};
</script>

<style scoped lang="scss">
.search {
  position: relative;
  max-width: 600px;
  width: 100%;
  margin: 0 16px;
  padding: 0 15px;

  &-icon {
    position: absolute;
    height: 20px;
    top: 50%;
    transform: translateY(-50%);
    left: 29px;
  }

  input {
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #BDBDBD;
    box-sizing: border-box;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    height: 37px;
    outline: none;
    padding: 0 40px;
    font-size: 16px;
  }

  .clear-text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 14px;
  }
}
</style>
